import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser, isSiteAuthorized } from '@/auth/utils'
import store from '@/store'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import pages from './routes/pages'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'dashboard' } },
    ...apps,
    ...dashboard,
    ...pages,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

const blockedRoutePrefixes = ['/marketing', '/bdm', '/promotions', '/report']

router.beforeEach((to, _, next) => {
  // SSO landing opens the Authorize gate itself once the token is verified
  if (to.name === 'auth-sso') return next()
  if (!isSiteAuthorized()) {
    return to.name === 'authorize' ? next() : next({ name: 'authorize' })
  }
  if (to.name === 'authorize') return next({ path: '/' })

  const isLoggedIn = isUserLoggedIn()

  if (blockedRoutePrefixes.some(prefix => to.path === prefix || to.path.startsWith(`${prefix}/`))) {
    if (!isLoggedIn) return next({ name: 'auth-login' })

    return next({ name: 'not-authorized' })
  }

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  // Protect dashboard: only allow users with full_access
  if (to.name === 'dashboard' && isLoggedIn) {
    const permissions = store.state.auth.permissions
    if (permissions?.full_access !== 'admin') {
      return next({ name: 'customers' })
    }
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
